import { useContext, useState } from 'react';
import IsomorphicStateContext from './context';
export const useIsomorphicState = (initial, key, value) => {
  const context = useContext(IsomorphicStateContext);
  const [data] = useState(context[key] || initial);
  const isSSR = typeof window === 'undefined';
  if (isSSR) {
    context[key] = value;
  }
  return data;
};